import { memo } from "react";
import { Box } from "@mui/material";

import Txt from "../../../../../components/typography/Txt";
import { formatBorrowerObjectFullName } from "../../../../../_src_shared/utils/functions/formatBorrowerObjectFullName";

import {
  PALETTE,
  Panel,
  DateRow,
  fmtDate,
  fmtRelativeShort,
  parseIsoMs,
} from "./_shared";

// Per-borrower date fields surfaced in this card. Each entry pulls from
// `borrower[field]` and renders as its own DateRow with the borrower's
// name as the row subtitle.
const BORROWER_DATE_FIELDS = [
  {
    field: "creditAuthDate",
    what: "Credit auth signed",
    badgeLabel: "Credit Auth",
  },
  {
    field: "creditReportDate",
    what: "Credit report pulled",
    badgeLabel: "Credit Report",
  },
  {
    field: "backgroundDate",
    what: "Background check",
    badgeLabel: "Background",
  },
];

const BorrowerDatesCard = ({ loan }) => {
  const borrowers = loan?.borrowers || [];

  const rows = [];
  borrowers.forEach((b, idx) => {
    const name = formatBorrowerObjectFullName(b) || `Borrower ${idx + 1}`;
    BORROWER_DATE_FIELDS.forEach(({ field, what, badgeLabel }) => {
      const raw = b?.[field];
      if (!raw) return;
      rows.push({
        key: `${b?._id || idx}-${field}`,
        sortMs: parseIsoMs(raw) ?? 0,
        when: fmtDate(raw),
        whenSub: fmtRelativeShort(raw),
        what,
        whatSub: name,
        badgeLabel,
        badgeTone: "default",
        state: "default",
      });
    });
  });
  rows.sort((a, b) => a.sortMs - b.sortMs);

  return (
    <Panel title="Borrower dates" count={`${rows.length}`}>
      {rows.length === 0 ? (
        <Box sx={{ px: "22px", py: "20px" }}>
          <Txt
            sx={{
              fontSize: 12.5,
              color: PALETTE.ink3,
              fontStyle: "italic",
            }}
          >
            No borrower dates tracked yet.
          </Txt>
        </Box>
      ) : (
        rows.map((row, idx) => (
          <DateRow key={row.key} isFirst={idx === 0} {...row} />
        ))
      )}
    </Panel>
  );
};

export default memo(BorrowerDatesCard);
